/**
 * Числа так, как их читает человек на скорости.
 *
 * Разряды отбиваются тонким пробелом (U+2009), а не обычным: обычный переносится,
 * и «8 490 ₽» на узком экране рвётся на «8» и «490 ₽» — сумма, прочитанная как
 * две, это чужая ставка.
 */

const THIN = '\u2009';

/** Рубли без копеек. Копейки в ленте не нужны: ставка всё равно кратна десятке. */
export function rub(value: number): string {
  const rounded = Math.round(Math.abs(value));
  const body = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, THIN);
  return `${value < 0 ? '−' : ''}${body}`;
}

/** Доллары с центами: в зарубежную кассу вводят именно так, не целыми. */
export function usd(value: number): string {
  const sign = value < 0 ? '−' : '';
  const n = Math.abs(value);
  const [whole, frac] = n.toFixed(2).split('.');
  const body = (whole ?? '0').replace(/\B(?=(\d{3})+(?!\d))/g, THIN);
  return `${sign}${body}.${frac ?? '00'}`;
}

/** Секунды в человеческое «45 с» / «2 мин». Часы в ленте не встречаются. */
export function secs(value: number): string {
  if (value < 90) return `${Math.round(value)} с`;
  return `${Math.round(value / 60)} мин`;
}

/**
 * Время суток по часам браузера. Свежесть линии показывается временем, а не
 * возрастом: «11:42:03» проверяется взглядом на часы, «4 секунды назад»
 * приходится сверять с моментом, когда цифра нарисовалась.
 */
export function clock(at: number): string {
  const d = new Date(at);
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
